import styled from 'styled-components/macro';

import { rem } from '@blueprint/ui';

import { colors } from 'themes';

import { BaseContentBox } from './BaseContentBox';

const { black, white } = colors;

export const RichContentBox = styled(BaseContentBox)`
  ol,
  .va-faq-ul {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-top: ${rem(3)};
  }

  .marker a {
    border: ${rem(1)} solid ${black};
    border-radius: ${rem(16)};
    background: ${white};
    color: ${black};
    padding: ${rem(6)} ${rem(10)};
    text-decoration: none;
    display: inline-block;
    margin-bottom: ${rem(8)};
  }
`;
